import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"{{this.column.columnClass}} {{this.cellClass}} {{this.rowClass}}\">\n  <span class={{this.textClass}}>{{this.displayValue}}</span>\n</div>", {
  moduleName: "@dashboard/shared-ui/components/custom-ember-table-data-cell.hbs"
});